export default function ArrowRight({ className }) {
    return (
      <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 9.83008H13.9236"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round" />
        <path d="M10.229 13.6469L14.7248 9.83022L10.229 6"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round" />
      </svg>
    )
}
